import { render, staticRenderFns } from "./AddressDialog.vue?vue&type=template&id=db1b68ae&scoped=true"
import script from "./AddressDialog.vue?vue&type=script&lang=ts"
export * from "./AddressDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db1b68ae",
  null
  
)

export default component.exports